import {
    Controller
} from "stimulus"
import uniqid from 'uniqid'

export default class extends Controller {
    static targets = ['form']

    /**
     * Getter for the form element
     * @returns {HTMLFormElement|string|Element}
     */
    get form()
    {
        if (this.hasFormTarget) {
            return this.formTarget
        }
        let form = this.element.querySelector('form')
        if (!form) {
            return this.element
        }
        return form;
    }

    /**
     * Connected to dom.
     */
    connect()
    {
        this.start()
    }

    /**
     * Have the form listen for changes
     */
    start()
    {
        let action = this.form.dataset['action'] ? this.form.dataset['action'] + ' ' : ''
        action += 'input->ada-form#handleChange'
        this.form.dataset['action'] = action
        this.handleChange()
    }

    /**
     * Update form elements to make the ADA complaint
     */
    updateForm() {
        this.form.setAttribute('role', 'form')
        this.form.querySelectorAll('label').forEach(this.updateLabel.bind(this))
        this.form.querySelectorAll('input[type=checkbox]').forEach(this.updateCheckbox.bind(this))
        this.form.querySelectorAll('input[type=email]').forEach(this.updateText.bind(this))
        this.form.querySelectorAll('input[type=text]').forEach(this.updateText.bind(this))
        this.form.querySelectorAll('.inline_grid.choices').forEach(this.makeRadioGroup.bind(this))
        this.form.querySelectorAll('input[type=submit]').forEach(this.updateInputButton.bind(this))
        this.form.querySelectorAll('#CCY-ln').forEach(this.removeLoadCalculatorCCYLink.bind(this))
        this.form.querySelectorAll('.job_types').forEach(this.makeRadioGroup.bind(this))
    }

    /**
     * The form has changed
     */
    handleChange()
    {
        this.updateForm()
    }

    /**
     * Make sure checkboxes have aria-checked if checked.
     * @param checkbox
     */
    updateCheckbox(checkbox)
    {
        if (checkbox.checked) {
            checkbox.setAttribute('aria-checked', true)
        } else {
            checkbox.setAttribute('aria-checked', false)
        }
    }

    /**
     * Make sure text inputs have aria-labels
     * @param text
     */
    updateText(text)
    {
        if (text.placeholder && !text.getAttribute("aria-labelledBy")) {
            text.setAttribute("aria-label", text.placeholder)
        }
    }

    /**
     * Make sure buttons have aria-labels.
     * @param input
     */
    updateInputButton(input)
    {
        if (input.value && !input.getAttribute("aria-label")) {
            input.setAttribute("aria-label", input.value)
        }
    }

    /**
     * Put formsite choices in a radio group.
     * @param choices
     */
    makeRadioGroup(el)
    {
        el.setAttribute('role', 'radiogroup')
    }

    /**
     * Put labels in a radiogroup.
     * @param label
     */
    updateLabel(label)
    {
        if (!label.getAttribute('for')) {
            //No for, try to find some child inputs
            let inputs = label.parentElement.querySelectorAll('input');

            let input = inputs[0]

            if (!input.id) {
                input.id = uniqid('field-')
            }

            //If we found only one child, we have a match.
            if (inputs.length === 1) {
                label.setAttribute('for', input.id)
            }
        }
    }

    removeLoadCalculatorCCYLink(link)
    {
        link.remove();
        document.getElementById('CURRENCYDATE').remove()
    }

}
